import { getSystemAgent, isAlipayOrWechat } from '@/utils';
export default {
  name: 'App',
  created: function created() {
    this.handleDocumentInit();
  },
  methods: {
    handleDocumentInit: function handleDocumentInit() {
      getSystemAgent();
      isAlipayOrWechat();
    }
  }
};